module.exports = __webpack_public_path__ + "static/media/Duplicate-large.24e6ea81.svg";